import MockLoadingBlock from './MockLoadingBlock'
import classes from './MockWorkQ.module.css'

export default function MockWorkQ () {
    
    const header = [
        {
            id: 1
        },
        {
            id: 2
        },
        {
            id: 3
        },
        {
            id: 4
        },
        {
            id: 5
        },
        {
            id: 6
        }
    ]

    return <div>
        <div className={classes.header}>
            {header.map(item => (
                <MockLoadingBlock key={item.id} height={44} noBevel={true} noMargin={true}/>
            ))}
        </div>
        <MockLoadingBlock  height={300} noBevel={true} noMargin={true}/>
    </div>
}